export default __webpack_public_path__ + "static/media/sad.de652fc8.png";